import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon, CheckCircleIcon } from 'lucide-react';
export function ComparisonSection() {
  const negatives = ['Tu abdomen va a seguir hinchado cada día', 'Vas a seguir frustrada haciendo todo bien sin ver resultados', 'La incomodidad con tu cuerpo va a crecer', 'Con el tiempo, será más difícil revertirlo'];
  const positives = ['Tu abdomen empieza a desinflamarse en los primeros días', 'Te sentís más liviana, cómoda y segura con vos misma', 'Tu digestión mejora y tus comidas dejan de ser un problema', 'Volvés a sentirte bien en tu propio cuerpo'];
  return <section className="w-full bg-white py-16 px-4 md:px-8" data-id="element-39">
      <div className="max-w-4xl mx-auto" data-id="element-40">
        <div className="grid md:grid-cols-2 gap-6" data-id="element-41">
          {/* Negative */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-red-50 border border-red-200/50 rounded-2xl p-6" data-id="element-42">
            <h3 className="text-lg font-serif text-red-800 mb-5 flex items-center gap-2" data-id="element-43">
              <XCircleIcon className="w-5 h-5 text-red-500" data-id="element-44" />
              Si no hacés nada…
            </h3>
            <div className="space-y-3" data-id="element-45">
              {negatives.map((item, i) => <p key={i} className="flex items-start gap-2 text-red-700/80 text-sm" data-id="element-46">
                  <span className="text-red-400 mt-0.5 flex-shrink-0" data-id="element-47">❌</span>
                  {item}
                </p>)}
            </div>
          </motion.div>

          {/* Positive */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="bg-bg-mint border border-secondary/30 rounded-2xl p-6" data-id="element-48">
            <h3 className="text-lg font-serif text-text-dark mb-5 flex items-center gap-2" data-id="element-49">
              <CheckCircleIcon className="w-5 h-5 text-accent" data-id="element-50" />
              Si empezás hoy…
            </h3>
            <div className="space-y-3" data-id="element-51">
              {positives.map((item, i) => <p key={i} className="flex items-start gap-2 text-primary-mid text-sm" data-id="element-52">
                  <span className="text-accent mt-0.5 flex-shrink-0" data-id="element-53">✓</span>
                  {item}
                </p>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}